import { createFileRoute } from '@tanstack/react-router';
import CreateCodePage from '../views/create/code';

export const Route = createFileRoute('/create/$publicCode')({
  validateSearch: (search: Record<string, unknown>) => ({
    ...(typeof search.customer_volume === 'string'
      ? { customer_volume: search.customer_volume }
      : {}),
    completion: search.completion === 'scorecard' ? ('scorecard' as const) : undefined,
    delivery:
      search.delivery === 'text-email'
        ? ('text-email' as const)
        : search.delivery === 'text'
          ? ('text' as const)
          : search.delivery === 'email'
            ? ('email' as const)
            : undefined,
  }),
  component: CreateCodePage,
});
